export default "<img class=\"fade\" src=\"/assets/loading.svg\">"